import { format } from 'bloko/common/trl';

export const collapseListTitle = (items: string[], max: number, all: number, postfix: string) => {
    if (items.length <= max) {
        return items.join(', ');
    }
    return `${items.slice(0, max).join(', ')} ${format(postfix, { '{0}': all - max })}`;
};
